/*
 * @Author: bbqin
 * @Date: 2023-02-23 10:38:50
 * @LastEditTime: 2023-04-23 13:57:51
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\components\skeleton\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

import React, { Children, Component } from "react";

require('./index.less');

const defaultProps = {
    prefixCls: 'skeleton',
    active: false,
    avatar: false, // boolean || {}
    loading: false,
    paragraph: true, // boolean || {}
    title: true, // boolean
};

class Skeleton extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { loading, children, prefixCls, active, ...others } = this.props;

        if (loading) {
            return <div className={`${prefixCls}-wrapper ai-${prefixCls} ${active && (prefixCls + '-active')}`}>
                <div className={`${prefixCls}-header`}>
                    <div className={`${prefixCls}-left`}>
                        <div className={`${prefixCls}-avatar`}>
                        </div>
                    </div>
                    <div className={`${prefixCls}-right`}>
                        <ul className={`${prefixCls}-paragraph`}>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    </div>
                </div>
                <div className={`${prefixCls}-content`} >
                    <ul className={`${prefixCls}-paragraph`}>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
            </div>;
        } else {
            return children || null;
        }
    }
}

Skeleton.defaultProps = defaultProps;

export default Skeleton;